import * as styles from './styles';
import { STATUS_CANCELLED, STATUS_NO_SHOW } from 'services/constants';

export default ({ i18n, appointmentId, currentStatus }) => {
  let disabled = currentStatus === STATUS_NO_SHOW || currentStatus === STATUS_CANCELLED;

  return (
    <styles.EmptyBlockWrapper>
      <styles.EmptyBlock>
        <styles.InvoiceImg />
        <styles.InvoiceEmptyText>
          {i18n.t('invoice_not_created_yet_without_create_btn')}
        </styles.InvoiceEmptyText>
        {/* <styles.CreateNewInvoiceBtn 
          disabled={disabled}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
            }
          }}
          to={`/practitioner/appointments/${appointmentId}/create-invoice`}>
          {i18n.t('create_new_invoice')}
        </styles.CreateNewInvoiceBtn> */}
      </styles.EmptyBlock>
    </styles.EmptyBlockWrapper>
  );
};
